// import React from 'react';
// import ChapterPage from "../ChapterPage";
// import ContentPage from "../ContentPage";
// import {getData} from "../../requests/CRUD";
// import {TRAINING} from "../../consts/tables";

// export default class extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             page: '',
//         };
//     }

//     componentDidMount() {
//         this.fetch(this.props.params);
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
//             this.fetch(nextProps.params);
//     }

//     fetch(params) {
//         const keys = Object.keys(params);
//         const slugs = params && keys.length ? keys.map(key => params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');

//         getData({
//             tableCode: TRAINING,
//             options: {
//                 filter: [{
//                     text: '',
//                     code: 'DELETED',
//                     type: 'null',
//                 }, {
//                     text: subchapterParentSlug,
//                     code: 'PARENT_SLUG',
//                     type: 'exact',
//                 }],
//                 filterType: 'and',
//             }
//         }).then(res => {
//             if (res && res.success) {
//                 if (res.data.length) {
//                     this.setState({page: 'chapter'});
//                     return;
//                 }
//                 this.setState({page: 'content'});
//             }
//         });
//     }

//     render() {
//         if (this.state.page === 'chapter')
//             return <ChapterPage {...this.props}/>;
//         if (this.state.page === 'content')
//             return <ContentPage {...this.props}/>;
//         return (
//             <div className='page-rounded-corner-container'>
//                 <div className='page-header-container training'/>
//             </div>
//         )
//     }
// }
//#region Old Code
// import React from 'react';
// import ChapterPage from "../ChapterPage";
// import ContentPage from "../ContentPage";
// import {getData} from "../../requests/CRUD";
// import {TRAINING} from "../../consts/tables";

// export default class extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             page: '',
//         };
//     }

//     componentDidMount() {
//         this.fetch(this.props.params);
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
//             this.fetch(nextProps.params);
//     }

//     fetch(params) {
//         const keys = Object.keys(params);
//         const slugs = params && keys.length ? keys.map(key => params[key]) : [];
//         const subchapterParentSlug = slugs.join('/');

//         getData({
//             tableCode: TRAINING,
//             options: {
//                 filter: [{
//                     text: '',
//                     code: 'DELETED',
//                     type: 'null',
//                 }, {
//                     text: subchapterParentSlug,
//                     code: 'PARENT_SLUG',
//                     type: 'exact',
//                 }],
//                 filterType: 'and',
//             }
//         }).then(res => {
//             if (res && res.success) {
//                 if (res.data.length) {
//                     this.setState({page: 'chapter'});
//                     return;
//                 }
//                 this.setState({page: 'content'});
//             }
//         });
//     }

//     render() {
//         if (this.state.page === 'chapter')
//             return <ChapterPage {...this.props}/>;
//         if (this.state.page === 'content')
//             return <ContentPage {...this.props}/>;
//         return (
//             <div className='page-rounded-corner-container'>
//                 <div className='page-header-container training'/>
//             </div>
//         )
//     }
// }

//#endregion

import React from 'react';
import ChapterPage from "../ChapterPage";
import ContentPage from "../ContentPage";
import {getData} from "../../requests/CRUD";
import {TRAINING} from "../../consts/tables";
import { GET_TRAINING } from '../Graphql/Queries/TrainingQuery';
import { ApolloConsumer } from '@apollo/client';
import { fetchData } from '../Service/graphQlService';

export default class extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: '',
        };
        this.client = null;
        this.refresh = this.refresh.bind(this);
    }

    refresh() {
        this.fetch(this.props.params);
    }

    componentDidMount() {
        if(this.client){
        this.fetch(this.props.params);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
            this.fetch(nextProps.params);
    }

    fetch(params) {
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');
        let payloadFilter = {
            "PARENT_SLUG": subchapterParentSlug
          }
          //const token = localStorage.getItem('authToken');
        // this.client.query({
        //     query: GET_TRAINING, variables: {
        //         filter: [{ text: '', code: 'DELETED', type: 'null' },
        //         { text: subchapterParentSlug, code: 'PARENT_SLUG', type: 'exact' }],
        //         filterType: 'and'
        //     }
        //     this.client.query({
        //         query: GET_TRAINING,variables:{filters:payloadFilter},fetchPolicy: "no-cache",
        //         context: {
        //             headers: {
        //                 authorization: `Bearer ${token}`, // Bearer token added here
        //             },
        //         }
        // })
        fetchData(GET_TRAINING,{filters:payloadFilter})
        .then(res => {
            if (res && res.data.getTrainingFilter.data) {
                if (res.data.getTrainingFilter.data.length) {
                    this.setState({page: 'chapter'});
                    return;
                }
                this.setState({page: 'content'});
            }
        });
    }

    render() {
        if (this.state.page === 'chapter')
            return <ChapterPage {...this.props}/>;
        if (this.state.page === 'content')
            return <ContentPage {...this.props} onStructureChange={this.refresh}/>;
        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client
                }
                return (
            <div className='page-rounded-corner-container'>
                <div className='page-header-container training'/>
            </div>
             )
            }}
        </ApolloConsumer>
        )
    }
}